import React, { useState } from "react";
import { Quote, ChevronLeft, ChevronRight, Star } from "lucide-react";
import { TESTIMONIALS } from "../data/catalog";

export const Testimonials = () => {
  const [active, setActive] = useState(0);
  const t = TESTIMONIALS[active];

  return (
    <section
      data-testid="testimonials"
      className="relative bg-leduro-surface py-20 md:py-28 overflow-hidden"
    >
      <div className="leduro-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="leduro-eyebrow">— Customer Reviews</span>
            <h2 className="mt-3 font-heading font-black tracking-tighter text-leduro-navy text-3xl md:text-5xl text-balance max-w-2xl">
              Trusted by trade buyers and electrical contractors across the Baltics.
            </h2>
          </div>
          <div className="flex items-center gap-2 text-leduro-orange">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-current" />
            ))}
            <span className="ml-2 text-leduro-navy font-semibold text-sm">4.9 / 5 · 142 verified buyers</span>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-leduro-border border border-leduro-border">
          {/* Quote card */}
          <div className="lg:col-span-8 bg-white p-8 md:p-12 relative">
            <Quote className="h-14 w-14 text-leduro-orange/30 absolute top-8 right-8" />
            <p className="font-heading font-medium text-leduro-navy text-xl md:text-2xl lg:text-3xl leading-snug text-balance">
              "{t.quote}"
            </p>

            <div className="mt-10 flex items-center justify-between gap-6 flex-wrap">
              <div className="flex items-center gap-4">
                <div className="h-14 w-14 overflow-hidden border border-leduro-border shrink-0">
                  <img src={t.image} alt={t.name} className="h-full w-full object-cover" />
                </div>
                <div>
                  <div className="font-bold text-leduro-navy">{t.name}</div>
                  <div className="text-sm text-leduro-muted">{t.role}</div>
                  <div className="text-xs text-leduro-orange font-semibold tracking-wider uppercase mt-0.5">
                    {t.company}
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-2">
                <button
                  onClick={() => setActive((active - 1 + TESTIMONIALS.length) % TESTIMONIALS.length)}
                  data-testid="testimonial-prev"
                  aria-label="Previous testimonial"
                  className="h-11 w-11 grid place-items-center border border-leduro-border text-leduro-navy hover:bg-leduro-navy hover:text-white transition-colors"
                >
                  <ChevronLeft className="h-5 w-5" />
                </button>
                <button
                  onClick={() => setActive((active + 1) % TESTIMONIALS.length)}
                  data-testid="testimonial-next"
                  aria-label="Next testimonial"
                  className="h-11 w-11 grid place-items-center border border-leduro-border bg-leduro-orange text-white hover:bg-leduro-orange-dark transition-colors"
                >
                  <ChevronRight className="h-5 w-5" />
                </button>
              </div>
            </div>
          </div>

          {/* Reviewer list */}
          <div className="lg:col-span-4 bg-white">
            {TESTIMONIALS.map((r, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                data-testid={`testimonial-pick-${i}`}
                className={`w-full flex items-center gap-4 text-left p-5 border-b border-leduro-border last:border-b-0 transition-colors ${
                  active === i ? "bg-leduro-surface" : "hover:bg-leduro-surface/60"
                }`}
              >
                <div className={`h-12 w-12 overflow-hidden border-2 shrink-0 ${active === i ? "border-leduro-orange" : "border-leduro-border"}`}>
                  <img src={r.image} alt={r.name} className="h-full w-full object-cover" />
                </div>
                <div className="min-w-0 flex-1">
                  <div className={`font-bold text-sm truncate ${active === i ? "text-leduro-orange" : "text-leduro-navy"}`}>
                    {r.name}
                  </div>
                  <div className="text-xs text-leduro-muted truncate">{r.company}</div>
                </div>
                {active === i && <span className="w-1.5 h-8 bg-leduro-orange shrink-0" />}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
